import { render } from "./BoardOfDirectorsView.vue?vue&type=template&id=74adf7e1&scoped=true"
import script from "./BoardOfDirectorsView.vue?vue&type=script&lang=js"
export * from "./BoardOfDirectorsView.vue?vue&type=script&lang=js"

import "./BoardOfDirectorsView.vue?vue&type=style&index=0&id=74adf7e1&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74adf7e1"]])

export default __exports__